// extracted by mini-css-extract-plugin
export default {"itemToggler":"TableItemToggler_itemToggler__Zox2h","itemTogglerCollapsed":"TableItemToggler_itemTogglerCollapsed__DcySj"};